export default "__VITE_ASSET__Cd4pv5jR__"